import { Circle, G, Path } from "@react-pdf/renderer";

type PdfActivityIconProps = {
  x?: number;
  y?: number;
};

export const PdfActivityIcon = ({ x = 0, y = 0 }: PdfActivityIconProps) => {
  return (
    <G transform={`translate(${x}, ${y})`}>
      <Circle cx={8.33333} cy={8.33333} r={8.33333} fill="#0A1A53" />
      <Path
        d="M7.44727 3.68555C7.97604 3.2965 8.69583 3.2965 9.22461 3.68555L12.9287 6.41016C13.1848 6.59861 13.3359 6.89784 13.3359 7.21582V11.832C13.3359 12.6605 12.6644 13.332 11.8359 13.332H4.83594C4.00751 13.332 3.33594 12.6605 3.33594 11.832V7.21582C3.33594 6.89784 3.48705 6.59861 3.74316 6.41016L7.44727 3.68555ZM6.19336 10.7568V11.7861H10.4795V10.7568H6.19336ZM6.19336 10.1309H10.4795V9.10156H6.19336V10.1309ZM8.33496 5.97461C7.73469 5.97474 7.2481 6.46123 7.24805 7.06152C7.24805 7.66186 7.73466 8.1483 8.33496 8.14844C8.93538 8.14844 9.42285 7.66194 9.42285 7.06152C9.4228 6.46115 8.93535 5.97461 8.33496 5.97461Z"
        fill="#FBFCFF"
      />
    </G>
  );
};
